import React, { Fragment } from "react";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import equal from "fast-deep-equal";
import FleetWebApi from "../Api/FleetWebApi";
import DomainDetails from "./DomainDetails";
import TeamDetails from "./TeamDetails";
import LocationDetails from "./LocationDetails";
import NotesDetails from "../Notes/Notes";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

class DomainDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      domainDetails: null,
      redirect: null,
      tabValue: 0,
      domain: props.domain,
    };
  }

  handleChange = (event, newValue) => {
    this.setState({ tabValue: newValue });
  };
  componentDidUpdate(prevProps) {
    if (!equal(this.props, prevProps)) {
      console.log("Not equal props");
      this.setState({
        isLoaded: false,
        domain: this.props.domain,
      });
      this.getDomain(this.props.domain);
    }
  }

  componentDidMount() {
    this.getDomain(this.props.domain);
  }
  getDomain = (domain, domainDetails) => {
    FleetWebApi.getDomain(domain).then(
      (result) => {
        this.setState({
          isLoaded: true,
          domainDetails: result,
        });
      },
      (error) => {
        this.setState({
          isLoaded: true,
          error,
        });
      }
    );
  };

  render() {
    let ownerDetailsContainer;
    let teamMemberContainer;
    let locationsContainer;
    let NotesContainer;

    const { error, isLoaded, domainDetails } = this.state;
    if (error) {
      ownerDetailsContainer = <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      ownerDetailsContainer = (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
      teamMemberContainer = (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
      locationsContainer = (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
      NotesContainer = (
        <div>
          <CircularProgress color="secondary" />
        </div>
      );
    } else {
      ownerDetailsContainer = <DomainDetails domainDetails={domainDetails} />;
      teamMemberContainer = (
        <TeamDetails
          teamDetails={domainDetails.response.teamMembers}
          pendingTeamDetails={domainDetails.response.pendingTeamMembers}
          removedTeamDetails={domainDetails.response.removedTeamMembers}
        />
      );
      locationsContainer = (
        <LocationDetails locationDetails={domainDetails.response.Locations} />
      );
      try {
        NotesContainer = (
          <NotesDetails Id={this.props.domain} model_type="Domain" />
        );
      } catch (error) {
        console.log("error loading notes");
      }
    }

    return (
      <Fragment>
        <h1>
          {this.state.domainDetails
            ? this.state.domainDetails.response.admin.email
            : "Hold on man"}
        </h1>

        <AppBar position="static" style={{ background: "#2E3B55" }}>
          <Tabs
            value={this.state.tabValue}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            indicatorColor="secondary"
          >
            <Tab label="Domain Summary" />
            <Tab
              label="TeamMember Details"
              disabled={
                error ||
                (isLoaded === true &&
                  domainDetails.response.teamMembers.length === 0 &&
                  domainDetails.response.pendingTeamMembers.length === 0 &&
                  domainDetails.response.removedTeamMembers.length === 0)
              }
            />
            <Tab
              label="Location Details"
              disabled={
                error ||
                (isLoaded === true &&
                  domainDetails.response.Locations.length === 0)
              }
            />
            <Tab label="Notes" />
          </Tabs>
        </AppBar>

        <TabPanel value={this.state.tabValue} index={0}>
          <h2>Domain Summary</h2>
          {ownerDetailsContainer}
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={1}>
          <Grid item>
            <h2>TeamMember Details</h2>
            {teamMemberContainer}
          </Grid>
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={2}>
          <h2>Location Details</h2>
          <Grid item>{locationsContainer}</Grid>
        </TabPanel>
        <TabPanel value={this.state.tabValue} index={3}>
          <Grid item>
            <h2>Notes</h2>
            {NotesContainer}
          </Grid>
        </TabPanel>
      </Fragment>
    );
  }
}

export default DomainDashboard;
